import generateScriptElement from '@capsule/generate-script-element'

export default class ArticleTextToSpeech {
	private cta: HTMLElement | null
	private targetAudion: HTMLElement | null
	private audionPlayInitButton: HTMLElement | null = null
	private audionPlayButton: HTMLElement | null = null
	private playerId: string

	constructor() {
		this.cta = document.querySelector('.articleTextToSpeech')
		this.targetAudion = document.querySelector('[data-target-audion]')
		this.playerId = this.cta?.getAttribute('data-player-id') || ''

		this.initAudio = this.initAudio.bind(this)
		this.playAudion = this.playAudion.bind(this)
	}

	init() {
		if (this.cta && this.playerId) {
			this.addEvents()
		}
	}

	addEvents() {
		this.cta?.addEventListener('click', this.initAudio)
	}

	initAudio() {
		if (!this.targetAudion) return

		this.targetAudion?.insertAdjacentHTML(
			'beforeend',
			'<div class="articleTextToSpeech-text2Speech text2SpeechContainer"></div>'
		)

		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				if (mutation.type === 'childList') {
					this.audionPlayInitButton =
						this.targetAudion?.querySelector(
							'.audion-360-print-audio-player-btnIdle'
						) || null
					if (this.audionPlayInitButton) {
						setTimeout(() => {
							this.audionPlayInitButton?.dispatchEvent(
								new MouseEvent('pointerup', {
									bubbles: true,
									cancelable: true
								})
							)
						}, 1000)
						observer.disconnect()
						this.cta?.removeEventListener('click', this.initAudio)
						this.cta?.addEventListener('click', this.playAudion)
					}
				}
			}
		})

		observer.observe(this.targetAudion, { childList: true, subtree: true })

		const script = generateScriptElement({
			src: `https://printaudio.360.audion.fm/public/playerScripts/v1/collections/${this.playerId}/player.js`
		})

		document.body.appendChild(script)
	}

	playAudion() {
		if (!this.audionPlayButton) {
			this.audionPlayButton =
				this.targetAudion?.querySelector('.PlayBtn_playBtn__audion') || null

			if (!this.audionPlayButton) return
		}

		this.audionPlayButton.click()
	}
}
